import Image from "next/image";

import { MdOutlineClose } from "react-icons/md";
import FilterByButton from "./filter-by-button";

import curve from "@/assets/footer-curve.svg";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "@hooks/useTranslation";
type FiltersWrapperProps = {
  children: React.ReactNode;
  count: number;
  title: string;
  onApply: () => void;
  onClear: () => void;
};

export default function FiltersWrapper({
  children,
  count,
  title,
  onApply,
  onClear,
}: FiltersWrapperProps) {
  const router = useRouter();
  const { t } = useTranslation();
  return (
    <div
      className={`relative bg-black overflow-y-auto flex flex-col md:h-fit md:w-fit rounded-xl h-full w-full`}
    >
      <div
        className={`bg-[#121212] border-b border-[#4B4B4B] w-full pb-6 pt-4 px-6 mb-4`}
      >
        <div className={`flex items-center justify-between w-full`}>
          <h2
            className={`font-bold text-white uppercase text-right md:w-full md:text-center md:self-center`}
          >
            {title}
          </h2>
          <Link
            href={{
              query: { ...router.query, show_filters: false },
            }}
            className="absolute right-0 mr-4 text-xl text-white"
            shallow
          >
            <MdOutlineClose size={24} />
          </Link>
        </div>

        <div className={"md:flex md:justify-center md:items-center"}>
          <FilterByButton className="mt-2" arrow="up" />
        </div>
      </div>
      {children}
      <div className="flex flex-col items-center justify-center w-full">
        <div className="md:hidden">
          <button
            onClick={onApply}
            className="text-white font-bold uppercase px-16 py-1 border-2 rounded-full border-primary-color bg-primary-color/50"
          >
            {t("spotprofile.apply")}
          </button>
          <p className="pt-1 text-white/60">
            <span className="text-primary-color">{count}</span> matching {title}
          </p>
        </div>
        <div className="hidden md:block w-full pb-4 bg-white">
          <Image className="object-cover w-full" src={curve} alt={""} />
          <div className="flex flex-col items-center justify-center">
            <p className="pb-2 text-center text-gray-500">
              <span className="text-2xl text-primary-color">{count}</span>{" "}
              matching {title}
            </p>
            <div className="grid w-full grid-flow-col grid-cols-3">
              <div className="col-span-1" />
              <button
                onClick={onApply}
                className="self-center px-6 py-1 font-bold text-black uppercase border-2 border-green-600 rounded-full bg-primary-color w-fit"
              >
                {t("spotprofile.apply_filters")}
              </button>
              <button
                onClick={onClear}
                className="px-2 py-1 text-primary-color w-fit first-letter:uppercase"
              >
                {t("spotprofile.clear_all")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
